import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useRouteMatch, useHistory, useLocation } from "react-router-dom";

import { authenticateSalesforce, updateSalesforce } from 'actions/integrations/salesforce';
import { deactivateIntegration, activatingIntegrationSuccedded } from 'actions/integrations/integrations';

import _ from 'lodash';

import { Row, Col, Button, Form, Image } from "react-bootstrap";

import cx from 'classnames';
import styles from './salesforce.module.scss';

import { getBaseUrl } from 'services/util';

import buildUrl from 'build-url';
import { toast } from 'react-toastify';
import { SuccessToast } from 'components/Toast';
const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}`;

export const SalesforceIntegration = () => {

  const dispatch = useDispatch();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const location = useLocation();
  const history = useHistory();

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const deactivating = useSelector(state => _.get(state, 'integrations.activated.deactivating', false));
  const errors = useSelector(state => _.get(state, 'integrations.salesforce.changes.error', null));
  const authenticating = useSelector(state => _.get(state, 'integrations.salesforce.changes.saving', false));
  const updating = useSelector(state => _.get(state, 'integrations.salesforce.changes.updating', false));

  const [authenticated, setAuthenticated] = useState(false);

  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type === 'salesforce';
  })

  const [state, setState] = useState({
    email: '',
    integrationId:'',
    syncLeadCreatedEvent: true,
    error: ''
  });

  useEffect(state => {
    if (integration && integration.state.code === "ok" && !errors) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
    }

    if (integration != null && integration.configuration != null) {
      setState((state) => {
        return {
          ...state,
          email: _.get(integration, 'configuration.email'),
          integrationId: _.get(integration, 'id'),
          syncLeadCreatedEvent: _.get(integration, 'configuration.syncLeadCreatedEvent')
        }
      })
    }
    
  }, [integration]);

  const handleDeleteClick = () => {
    dispatch(deactivateIntegration('salesforce', (res) => {
      handleBackClick();
    }))
  }

  const handleBackClick = () => {
    var url = `${baseUrl}/integration-settings/integration`;
    history.push(url);
  }

  const handleAuthenticate = () => {
    //Calculate Position
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/1.0/integrations/salesforce/authorize`
    })

    var newWindow = window.open(url, `Authorize salesforce Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, handleAuthenticateEvent, false);
    return false;
  }

  const handleAuthenticateEvent = (e) => {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type === 'SALESFORCE_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;

      if (!error) {
        dispatch(authenticateSalesforce(code, (response) => {
          dispatch(activatingIntegrationSuccedded(response))
        }))
      }

      deEventer(messageEvent, handleAuthenticateEvent, false);
    }
  }

  const handleResetClick = () => {
    setState((state) => {
      return {
        ...state,
        syncLeadCreatedEvent: _.get(integration, 'configuration.syncLeadCreatedEvent'),
      }
    })
  }

  const handleSaveClick = () => {
    var request = {
      integrationId: state.integrationId,
      syncLeadCreatedEvent: state.syncLeadCreatedEvent,
    }

    dispatch(updateSalesforce(request, (response) => {
      toast(
        <SuccessToast
          heading={`Success`}
          description={"SalesForce Integration Updated Successfully"}
        />,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      dispatch(activatingIntegrationSuccedded(response))
    }))
  }

  const handleSyncEvents = (event) => {
    setState((state) => {
      return {
        ...state,
        [event]: !state[event]
      }
    })
  }

  const integrationData = location.state;

  return (
    <div className={styles.salesforceContent}>
      <Button variant='light' onClick={handleBackClick} className={styles.backButton} >
        <i className="cleverstory-left" />
        Back
      </Button>
      <div className={styles.formContainer}>
        <Row className={styles.cardWrapper}>
          <Col className={styles.integrationDetail} md={5}>
            <div className={styles.logoContainer}>
              <Image src={integrationData.logo} />
            </div>
            <div className={styles.detailContainer}>
              <span className={styles.title}>{integrationData.title}</span>
              <span className={styles.description}>{integrationData.description}</span>
              {integration && <Button variant='secondary' onClick={handleDeleteClick} className={styles.deactivateButton} >{deactivating ? 'Deactivating...' : 'Deactivate'}</Button>}
              {!integration && <span className={styles.inactiveStatus}>INACTIVE</span>}
            </div>
          </Col>
          <Col className={styles.authForm} md={7}>
            <div className={styles.salesforceAuthentication}>
              {!authenticated &&
                <div className={styles.salesforceConfig}>
                  <h3 className={styles.configTitle}>Log in to your Salesforce account</h3>
                  <span className={styles.configDescription}>Please provide a user account with global access</span>
                  <Button variant='primary' className={styles.authButton} onClick={handleAuthenticate}>
                    {authenticating &&
                      'Authenticating...'
                    }

                    {!authenticating &&
                      'Authenticate'
                    }
                  </Button>
                </div>
              }
              {authenticated && <div className={styles.formWrapper}>
                <Form.Group className="mb-3" controlId="id">
                  <Form.Label className={styles.inputLabel}>EMAIL</Form.Label>
                  <Form.Control className={styles.inputField} value={state.email} name="email" type="text" placeholder="Enter Email" />
                </Form.Group>

                <div className={styles.syncEvents}>
                  <span className={styles.inputLabel}>Sync Event</span>
                  <div className={styles.toggleSwitchContainer}>
                    <span className={cx(styles.content, {[styles.active]: state.syncLeadCreatedEvent})}>Create a Lead</span>
                    <Form.Check
                      type="switch"
                      checked={state.syncLeadCreatedEvent}
                      onChange={() => handleSyncEvents('syncLeadCreatedEvent')}
                      className={styles.toggleSwitch}
                      id="lead-visits"
                    />
                  </div>
                </div>

              </div>}
            </div>
          </Col>
        </Row>
      </div>
      {authenticated &&
        <div className={styles.actionContainer}>
          <Button variant='secondary' onClick={handleResetClick} className={styles.resetButton}>Reset</Button>
          <Button variant='primary' onClick={handleSaveClick} className={styles.saveButton}>{updating ? 'Saving...' : 'Save Changes'}</Button>
        </div>
      }
    </div>
  )
}
